export var Colors;
(function (Colors) {
    Colors["White"] = "#ffffff";
    Colors["LightGray"] = "#cccccc";
    Colors["Gray"] = "#323232";
    // Light Theme
    Colors["Green"] = "#50eba9";
    Colors["Red"] = "#E02020";
    Colors["Canary"] = "#FAEB3F";
    // Dark Theme
    Colors["Move"] = "#54f0f7";
    Colors["Exercise"] = "#c1ff00";
    Colors["Stand"] = "#ef135f";
})(Colors || (Colors = {}));
export const THEMES = {
    dark: {
        LegendColorPercentage: Colors.White,
        LegendColor: Colors.LightGray,
        RingColors: [Colors.Stand, Colors.Exercise, Colors.Move]
    },
    light: {
        LegendColorPercentage: Colors.Gray,
        LegendColor: Colors.LightGray,
        RingColors: [Colors.Green, Colors.Canary, Colors.Red]
    }
};
